import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { finalize } from "rxjs/operators";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";

import { FacturaService } from "../../shared/services/rest/factura.service";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";

import { locale as english } from "./i18n/en";
import { locale as spanish } from "./i18n/es";
import { FacturaDTO } from "../../shared/interfaces/factura.interface";
import { Filtro } from "../../shared/interfaces/filtro.interface";
import { FiltroFactura } from "../../shared/interfaces/filtro-factura.interface";
import { ClienteService } from "../../shared/services/rest/cliente.service";
import { ClienteDTO } from "../../shared/interfaces/cliente.interface";
import { FiltrosService } from "../../shared/services/util/filtros.service";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "app-facturas",
    templateUrl: "./facturas.component.html",
    styleUrls: ["./facturas.component.scss"],
})
export class FacturasComponent implements OnInit, OnDestroy {
    total:number;
    facturas: FacturaDTO[];
    configuracionFacturas: any = {};
    subscripciones: Subscription;
    estados: Filtro[];
    mostrarFiltros: boolean;
    
    esRepresentante: boolean;
    clientes: ClienteDTO[];
    setearFiltros: boolean;
    
    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _facturaSrvc: FacturaService,
        private _menuUsuarioSrvc: MenuUsuarioService,
        private _clienteSrvc: ClienteService,
        private _filtroSrvc: FiltrosService,
        private activatedRoute: ActivatedRoute
    ) {

        this._filtroSrvc.getFiltro("filtrosFacturas");
        this.activatedRoute.queryParams.subscribe((queryParams) => {
            if (Object.entries(queryParams).length > 0) {
                this.setearFiltros = true;
                //console.log('filtros aqui van ')
                //console.log(queryParams);
                this.mostrarFiltros = true;
                //setear los filtros
                if (queryParams.idEstado) {
                    this._filtroSrvc.setFiltro(
                        "filtrosFacturas",
                        "estado",
                        queryParams.idEstado,
                        queryParams.nombre
                    );
                }
            } else {
                this.mostrarFiltros = false;
                this.setearFiltros = false;
            }
        });



        //this.mostrarFiltros = false;
        this.subscripciones = new Subscription();
        this._fuseTranslationLoaderService.loadTranslations(english, spanish);
    }

    ngOnInit(): void {
        this.buscarFacturas();

        this.estados = [
            {
                valor: 1,
                descripcion: "Impagas",
                tipo: null,
            },
            {
                valor: 2,
                descripcion: "Pagadas",
                tipo: null,
            },
        ];

        if (this._menuUsuarioSrvc.esSupervisor()) {
            this._clienteSrvc
                .fetchClientes(0, "desc")
                .subscribe((resp) => (this.clientes = resp.content));
        } else {
            this.clientes = [];
        }

        this.esRepresentante = this._menuUsuarioSrvc.esRepresentante();
        
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }

    buscarFacturas() {
        this._fuseProgressBarService.show();
        this.subscripciones.add(
            this._facturaSrvc
                .fetchFacturas()
                .pipe(finalize(() => this._fuseProgressBarService.hide()))
                .subscribe((resp) => {

                    //console.log(resp);

                    this.facturas = resp.content;
                    this._facturaSrvc.facturasChanged$.next(resp);
                    this._facturaSrvc.setCantidadPaginas(resp.totalPages);
                    this.total = resp.totalElements;
                    //this._facturaSrvc.setTotalDeResultados(
                    //    resp.totalElements
                    //);
                    this._facturaSrvc.setPaginaActual(
                        resp.pageable.pageNumber
                    );
                    this._facturaSrvc.setCantidaResultadosPorPagina(
                        resp.size
                    );
                })
        );
    }

    filtrar(event: FiltroFactura) {
        this._facturaSrvc.resetPaginador();
        this._facturaSrvc.facturasRefresh$.next(true);
    }

}
